var loginMain = require('./login.js');

$(function () {
    loginMain.loginStart();
});